export const GWP_PRODUCT_IDS_BCOM = ['6226329', '6229394', '6215032'];
export const GWP_PRODUCT_IDS_MCOM = ['11492845', '12625896', '16994434'];
